export default "__VITE_ASSET__$GnoTyKe__"